import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import validationSchema from './validation';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import RoleOptions from '../../../../utils/RoleOptions';
import TheaterAutocompleteField from '../../../Others/TheaterAutocompleteField';
import Textarea from '../../../../components/Textarea';
import UploadImageField from '../../../../components/UploadImageField';
import ValidatesFormWith from '../../../../utils/ValidatesFormWith';


class UserForm extends React.Component {
  process = (values) => {
    const user = {
      name: values.name,
      type: values.type,
      email: values.email,
      password: values.password,
      website: values.website,
      biography: values.biography,
      images: values.images.map(i => ({
        url: i.url,
      })),
      theaterId: values.theater && values.theater.id,
    };

    this.props.onSubmit(user);
  };

  render() {
    const {
      user,
    } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={{
          name: user.name || '',
          type: user.type || '',
          email: user.email || '',
          password: '',
          website: user.website || '',
          theater: user.theater || { name: '' },
          biography: user.biography || '',
          images: user.images || [],
        }}
        onSubmit={this.process}
        validate={ValidatesFormWith(validationSchema)}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            {this.props.title && (
              <h1>{this.props.title}</h1>
            )}
            <div className="search-contents-sidebar">
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Nombre"
                    name="name"
                  />
                </div>
                <div className="col-md-6">
                  <Select
                    label="Rol"
                    name="type"
                    placeholder="Selecciona un rol"
                    options={RoleOptions}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Correo electrónico"
                    name="email"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Contraseña"
                    name="password"
                    type="password"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Sitio web"
                    name="website"
                  />
                </div>
                <div className="col-md-6">
                  <TheaterAutocompleteField
                    label="Teatro asociado"
                    name="theater"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Textarea
                    label="Biografía"
                    name="biography"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <UploadImageField
                    label="Imágenes"
                    name="images"
                  />
                </div>
              </div>
              <div className="m-b-md m-t-md">
                <button type="submit" className="book-btn">
                  <span className="book-btn-l">
                    <i className="fa fa-save" />
                  </span>
                  <span className="book-btn-r">Guardar</span>
                  <div className="clear" />
                </button>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

UserForm.propTypes = {
  title: PropTypes.string,
  user: PropTypes.object,
  onSubmit: PropTypes.func,
};

UserForm.defaultProps = {
  title: undefined,
  user: {},
  onSubmit: () => {},
};

export default UserForm;



// WEBPACK FOOTER //
// ./src/containers/Admin/User/Form/index.js